import { AnyAction, Dispatch } from "redux";
import { getVideos } from "../api/videosApi";
import { handleActionError } from "./actionErrorHandler";
import { VideoResponse } from "../types/videos";
import { commonActionKeys } from "./commonActionKeys";

export const getVideosSuccess = (videoRes: VideoResponse): AnyAction => {
  return {
    type: commonActionKeys.LOAD_VIDEOS_SUCCESS,
    videoRes
  };
};

export const getVideosAction = async (path: string, dispatchError: boolean = true) => {
  return async (dispatch: Dispatch): Promise<boolean> => {
    try {
      const settings = await getVideos(path);
      dispatch(getVideosSuccess(settings));
      return true;
    } catch (error) {
      handleActionError(error, dispatch, dispatchError);
      return false;
    }
  };
};
